
if(!__webpack_require__.federation){
    __webpack_require__.federation = {
        
chunkMatcher: function(chunkId) {
    return /^(239|613|800|889|972|994)$/.test(chunkId);
},
rootOutputDir: "",

    };
}
